import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../connector'

export interface SirOnboardingSettingsResource {
  globalOnboardingEndpoint: SirOnboardingSettingsResourceGlobalOnboardingEndpoint
}

export interface SirOnboardingSettingsResourceGlobalOnboardingEndpoint {
  /** Hostname to use for API calls and redirection to global onboarding. */
  hostName: string
  /** Port to use for API calls and redirection to global onboarding. */
  port: number
  /** Protocol to use for API calls and redirection to global onboarding. */
  protocol: SirOnboardingSettingsResourceGlobalOnboardingEndpointProtocol
}
/**
 * Protocol to use for API calls and redirection to global onboarding.
 */
export type SirOnboardingSettingsResourceGlobalOnboardingEndpointProtocol =
  (typeof SirOnboardingSettingsResourceGlobalOnboardingEndpointProtocol)[keyof typeof SirOnboardingSettingsResourceGlobalOnboardingEndpointProtocol]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SirOnboardingSettingsResourceGlobalOnboardingEndpointProtocol = {
  http: 'http',
  https: 'https'
} as const

export async function getSirOnboardingSettings(
  this: ThisConnector,
  organizationUuid: string
): Promise<SirOnboardingSettingsResource> {
  // This is behind the API gateway not the standard Contrast API URL, once the Card is moved to the MFE https://contrast.atlassian.net/browse/TS-23570 this code can be removed
  const config = await this.connector.get(
    `../../../api/ui/organizations/${organizationUuid}/sir/onboarding/settings`
  )

  return config
}

export function useSirOnboardingSettings(
  organizationUuid: string,
  enabled?: boolean
) {
  return useContrastQuery<string, SirOnboardingSettingsResource>(
    [Query.SIR_ONBOARDING_CONFIG],
    getSirOnboardingSettings,
    organizationUuid,
    { notifyOnChangeProps: 'tracked', enabled }
  )
}
